module.exports = [{"name":"Margaret E.","photo":"testimonials-1.jpg","quote":"I love the visualisations! They are interactive and very useful for my purposes."},{"name":"Fred S.","photo":"testimonials-2.jpg","quote":"It's great to have all relevant indicators on one platform! "},{"name":"Sarah W.","photo":"testimonials-3.jpg","quote":"The social dimension is both unique and insightful. "}]


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/testimonials.json
// module id = DLpp
// module chunks = 6